import { attachMenuSounds } from './MenuSounds';
import { musicMute } from './MusicMute';

export class MusicToggle {
  readonly root: HTMLButtonElement;
  private armedPointerId: number | null = null;
  private readonly windowRelease: (e: Event) => void;

  constructor(parent: HTMLElement) {
    this.root = document.createElement('button');
    this.root.id = 'music-toggle';
    this.root.className = 'tst-btn tst-btn-sm';
    this.root.type = 'button';
    this.root.title = 'Mute music';

    const fire = (): void => {
      musicMute.toggle();
      this.refresh();
    };

    const releasePress = (): void => {
      if (this.armedPointerId !== null) {
        try { this.root.releasePointerCapture(this.armedPointerId); } catch { /* ignore */ }
        this.armedPointerId = null;
      }
      this.root.classList.remove('is-pressed');
    };

    this.root.addEventListener('pointerdown', (e: PointerEvent) => {
      e.preventDefault();
      this.armedPointerId = e.pointerId;
      this.root.classList.add('is-pressed');
      try { this.root.setPointerCapture(e.pointerId); } catch { /* ignore */ }
    });

    this.root.addEventListener('pointerup', (e: PointerEvent) => {
      if (this.armedPointerId !== e.pointerId) return;
      releasePress();
      fire();
    });

    const cancel = (e: PointerEvent): void => {
      if (this.armedPointerId !== e.pointerId) return;
      releasePress();
    };
    this.root.addEventListener('pointercancel', cancel);
    this.root.addEventListener('lostpointercapture', cancel);

    this.root.addEventListener('click', (e: MouseEvent) => {
      if (e.detail !== 0) return;
      fire();
    });

    this.windowRelease = (e: Event): void => {
      const pe = e as PointerEvent;
      if (this.armedPointerId === null) return;
      if (this.armedPointerId !== pe.pointerId) return;
      releasePress();
    };
    window.addEventListener('pointerup', this.windowRelease);
    window.addEventListener('pointercancel', this.windowRelease);

    attachMenuSounds(this.root);
    musicMute.subscribe(() => this.refresh());

    this.refresh();
    parent.appendChild(this.root);
  }

  refresh(): void {
    const muted = musicMute.isMuted();
    this.root.textContent = muted ? 'Music Off' : 'Music On';
    this.root.classList.toggle('tst-btn-ghost', muted);
  }
}
